/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { getShouldShowUnregisteredOnboarding } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';
import InlineLearningGoalQuestion from 'bundles/onboarding-common/components/InlineLearningGoalQuestion';

const styles = {
  container: css`
    && {
      margin-bottom: var(--cds-spacing-800);
    }
  `,
};

const OnboardingModuleRenderer = () => {
  const shouldShowOnboarding = getShouldShowUnregisteredOnboarding();

  if (!shouldShowOnboarding) {
    return null;
  }

  return (
    <PageGridContainer css={styles.container}>
      <Grid item xs={12}>
        <InlineLearningGoalQuestion />
      </Grid>
    </PageGridContainer>
  );
};

export default OnboardingModuleRenderer;
